import JsonLd from 'app/utilities/JsonLd';
import { parseVideoUrl } from 'app/utilities/video';
import PropTypes from 'prop-types';
import React from 'react';

const Video = ({ data }) => {
    const { credit, title, video_url: videoUrl } = data;

    if (!videoUrl) {
        return null;
    }

    const videoInfo = parseVideoUrl(videoUrl);

    if (!videoInfo || (videoInfo.provider !== 'youtube' && videoInfo.provider !== 'vimeo')) {
        return (
            <section className="content-media-block">
                <div className="constrain-width large">
                    <div className="inner">
                        <div className="content">
                            <header className="title-group">
                                <span className="heading-5">Video</span>
                                {title && <h2>{title}</h2>}
                                <p>Unsupported video URL</p>
                            </header>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    const getEmbedUrl = () => {
        if (videoInfo.provider === 'youtube') {
            return `https://www.youtube.com/embed/${videoInfo.id}?rel=0&controls=1&showinfo=0`;
        } else if (videoInfo.provider === 'vimeo') {
            return `https://player.vimeo.com/video/${videoInfo.id}?controls=1&title=0&byline=0&portrait=0`;
        }

        return null;
    };

    const embedUrl = getEmbedUrl();
    const structuredData = title ? {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name: title,
        description: credit || title,
        embedUrl,
        url: videoUrl
    } : null;

    return (
        <section className="content-media-block">
            {structuredData && <JsonLd item={structuredData} />}
            <div className="constrain-width large">
                <div className="inner">
                    <div className="media">
                        <div className="media-inner || preserve-image-ratio">
                            <iframe
                                title={`${videoInfo.provider === 'youtube' ? 'YouTube' : 'Vimeo'} Video: ${title}`}
                                className="video"
                                src={embedUrl}
                                allowFullScreen={true}
                            />
                        </div>
                    </div>
                    <div className="content">
                        <header className="title-group">
                            <span className="heading-5">Video</span>
                            {title && <h2>{title}</h2>}
                            {credit && <p>{credit}</p>}
                        </header>
                    </div>
                </div>
            </div>
        </section>
    );
};

Video.propTypes = {
    data: PropTypes.object.isRequired
};

export default Video;
